var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slick',{ref:"slick",attrs:{"options":_vm.slickOptions}},_vm._l((_vm.slideData),function(item,i){return _c('Slide',{key:i,staticClass:"carousel-item",attrs:{"data":item,"type":item.type}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb9f257a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Viewer.vue
// module id = null
// module chunks = 